module.exports = __webpack_public_path__ + "img/2-give a deal.4daa7211.jpg";